export default __webpack_public_path__ + "static/media/pointer.67c4f0a8.svg";